<script>
/* eslint-disable */
import GeneralInformation from "../components/pages/recipe/GeneralInformation.vue";
import Ingredients from "../components/pages/recipe/Ingredients.vue";
import CreateUpdateIngredient from "../components/pages/recipe/ingredients/CreateUpdateIngredient.vue";
import { mapGetters } from "vuex";
export default {
  name: "Tabs",
  components: {
    GeneralInformation,
    Ingredients,
    CreateUpdateIngredient,
  },
  data() {
    return {
      tabIndex: 0,
      id: this.$route.params.id ? this.$route.params.id : null,
    };
  },
  watch: {
    tabIndex(val) {},
  },
  computed: {
    ...mapGetters({
      tabStatus: "recipes/tabStatus",
    }),
  },
  mounted() {
    this.$store.commit("commons/setPreloader", true);
    this.$store.commit(`recipes/setTabStatus`, false);
    this.$store.dispatch("recipes/getUnits");
    this.$store.dispatch("recipes/getIngredients");
    // this.$store.dispatch("recipes/getUsers");
    if (this.id) {
      this.$store
        .dispatch(`recipes/getRecipe`, this.$route.params.id)
        .then((res) => {
          setTimeout(() => {
            this.$store.commit(`recipes/setTabStatus`, false);
            this.$store.commit("commons/setPreloader", false);
          }, 100);
        });
    }
  },
  methods: {
    tabActivated(newTabIndex, oldTabIndex, event) {
      if (this.tabStatus) {
        if (confirm("Changes you made may not be saved.")) {
          this.$store.commit(`recipes/setTabStatus`, false);
        } else {
          event.preventDefault();
        }
      }
    },
  },
};
</script>

<template>
  <b-card no-body class="data-listing-tabs">
    <b-tabs card v-model="tabIndex" v-on:activate-tab="tabActivated">
      <b-tab title="General Information" active ref="startTab">
        <general-information> </general-information>
      </b-tab>
      <b-tab title="Ingredients/Instruction">
        <ingredients> </ingredients>
      </b-tab>
    </b-tabs>
    <create-update-ingredient></create-update-ingredient>
  </b-card>
</template>